import React from "react";

function ShortCutListWrapper({ children }) {
    return <div className="shortCutsub clear">{children}</div>;
}

export default ShortCutListWrapper;
